<div class="mgmt_branch">
  <div class="heading-background mt-5 mgmt-header-row">
    <h4 (click)="showData ? hideData() : resetAll()"
      role="button"
      class="clickable-cursor mgmt-title">
      <span [ngClass]="showData ? 'rotated' : 'not-rotated'">
        <mat-icon class="icon-color-fix ump-expand-section-icon">chevron_right</mat-icon>
      </span>
      Management Branch Hierarchy
    </h4>
    @if (showData) {
      <div class="mgmt-controls">
        <div style="display: flex; align-items: center; gap: 10px;">
          <mat-button-toggle-group (change)="onNodeGFToggle($event.value)" [(ngModel)]="selectorValue">
            <mat-button-toggle matTooltip="Show all nodes" value="All">All</mat-button-toggle>
            @for (item of allToggelButtonOption; track item) {
              <mat-button-toggle matTooltip="Show only {{item}}  nodes" value="{{item}}">{{item}}</mat-button-toggle>
            }
          </mat-button-toggle-group>
          @if (!isMassReleaseRevoke()) {
            <button class="btn btn-sm button-fix button-color-fix-orange" (click)="selectAllPossiblePENodesTAX()" matTooltip="Select all TAX">
              <mat-icon class="icon-color-fix">checklist_rtl</mat-icon>
            </button>
          }
        </div>
        <div style="display: flex; align-items: center; gap: 5px;">
          <mat-button-toggle-group (change)="onhierarchyTypeToggle($event.value)" [(ngModel)]="hierarchyType">
            <mat-button-toggle [matTooltip]="(isMassReleaseRevoke() ? 'Release/Revoke ' : 'Show ') + 'ACT nodes'" value="ACT">ACT</mat-button-toggle>
            <mat-button-toggle [matTooltip]="(isMassReleaseRevoke() ? 'Release/Revoke ' : 'Show ') + 'OPL nodes'" value="OPL">OPL</mat-button-toggle>
          </mat-button-toggle-group>
          @if (isMassReleaseRevoke() && hierarchyType=='OPL') {
            <mat-button-toggle-group (change)="onOPLTypeToggle($event.value)" [(ngModel)]="oplType">
              <mat-button-toggle matTooltip="Release/Revoke BUDM nodes" value="BUDM">BUDM</mat-button-toggle>
              <mat-button-toggle matTooltip="Release/Revoke BUDY nodes" value="BUDY">BUDY</mat-button-toggle>
            </mat-button-toggle-group>
          }
          @if (isMassReleaseRevoke()) {
            <mat-button-toggle-group (change)="onBranchLevelToggle($event.value)" [(ngModel)]="branchLevel">
              <mat-button-toggle matTooltip="Release/Revoke only Management branches" value="MANAGEMENT"><mat-icon>corporate_fare</mat-icon></mat-button-toggle>
              <mat-button-toggle matTooltip="Release/Revoke only Field Branches" value="FIELDBRANCH"><mat-icon>store</mat-icon></mat-button-toggle>
              <mat-button-toggle matTooltip="Release/Revoke both Management and Field Branches" value="BOTH"><mat-icon>select_all</mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
          }
        </div>
      </div>
    }
    @if (showData && (showEdit || showViewGroupFunctions) && !isMassReleaseRevoke()) {
      <div class="mgmt-search">
        <button (click)="editGroupFunctions()" type="button" class="btn button-fix button-color-fix-orange">
          {{ showEdit ? 'Edit Group Functions' : 'View Group Functions' }}
          <mat-icon class="icon-color-fix">{{ showEdit ? 'edit' : 'visibility' }}</mat-icon>
        </button>
      </div>
    }
    @if (showData) {
      <div class="mgmt-search">
        <input class="form-control" name="searchString" [(ngModel)]="searchString" type="text" (keyup)="treeControl.expandAll()" placeholder="Search" />
        <mat-slide-toggle matTooltip="Show only selected" class="toggle-show-only-selected" [(ngModel)]="showOnlySelected"></mat-slide-toggle>
        <button aria-label="Collapse All" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.collapseAll()">
          <mat-icon class="icon-color-fix">unfold_less</mat-icon>
        </button>
        <button aria-label="Expand All" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.expandAll()">
          <mat-icon class="icon-color-fix">unfold_more</mat-icon>
        </button>
      </div>
    }
  </div>
  @if (showData) {
    <div class="custom_small_panelbody_fix">
      @if (Tree_Response_State=== 1) {
        <div>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <mat-nested-tree-node class="mat-tree-node" *matTreeNodeDef="let node"
              matTreeNodeToggle
              [style.display]="showOnlySelected && !node.selected || this.searchString && hideLeafNode(node) || (!(selectorValue === 'All') && hideLeafNodeselector(selectorValue,node )) || this.accessNotAllowed(node) || !this.isHierarchyTypeSelected(node) || node.isHistoric ? 'none' : 'block'">
              <li class="mat-tree-node">
                <mat-checkbox class="checklist-leaf-node" (change)="itemToggle($event.checked,node, true)" [disabled]="node.disabled || !isEditAllowed(node)" [checked]="node.selected">{{node.groupName}} </mat-checkbox>
              </li>
            </mat-nested-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
              [style.display]="(showOnlySelected && !(node.selected || node.indeterminate)) || this.searchString && hideParentNode(node) || (!(selectorValue === 'All') &&  hideParentNodeselector(selectorValue,node )) || this.accessNotAllowed(node) || !this.isHierarchyTypeSelected(node) || node.isHistoric ? 'none' : 'block'">
              <!--[style.display]="showOnlySelected && !node.selected || this.searchString && hideLeafNode(node) || (!(selectorValue === 'All') &&  hideLeafNodeselector(selectorValue,node ))  ? 'none' : 'block'">-->
              <li>
                <div class="mat-tree-node">
                  <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.groupName">
                    <mat-icon class="mat-icon-rtl-mirror icon-color-fix">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                  <mat-checkbox [checked]="node.selected"
                    [disabled]="node.disabled || !isEditAllowed(node)"
                    [disabledInteractive]="true"
                    [indeterminate]="node.indeterminate && !node.selected"
                  (change)="itemToggle($event.checked,node, true)">{{node.groupName}}</mat-checkbox>
                </div>
                <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </li>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      }
      @if (Tree_Response_State===-2) {
        <div style=" padding: 20px !important;">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(4); track $index) {
              <div class="card__desc-text"></div>
            }
          </div>
        </div>
      }
    </div>
  }
  <!--<div class="panel-body">
  <button (click)="submit()" type="submit" class=" btn button-color-fix pull-right">
    Save
    <mat-icon class="icon-color-fix">add</mat-icon>
  </button>
</div>-->
</div>

